// extracted by mini-css-extract-plugin
export default {"background":"aboutfounder_background__fdcZn"};